<template>
  <app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">
  <div slot="operations">
<v-btn @click="deleteHistory()" class="white--text" color="red" block>очисть историю</v-btn>

  </div>
  </app-modalData>

</template>




<script>
import axios from 'axios'
export default {
props: ['modals','groups'],
 data: function(){
  return {
    modalData:{
     sb: {
       snackbar: false,
       color: 'success',
       text: ''
     },
     f: "",
     selectedItem: "in",
       header:{
         text:"",
          icon:"mdi-database",
         icons:[
           {
             name:"mdi-close",
             f:"close",
           },
         ]
       },
     bar: {
         items:[
           {
              itemName: 'in',
              text:'Новые подписчики',
              f: null,
           },
           {
              itemName: 'out',
              text:'Отписались',
              f: null,
           },

         ],
         status: ""
       },
     content:{
       type:'pages',
         items:{

             in:{
               foundData: {},
               meneger:{}
             },
             out:{
               foundData: {},
               meneger:{}
             },


         },
       },


     operations:{

     }

    },
  }
},

methods: {

  f(fName){
  eval('this.'+fName+'()')
  },

deleteHistory(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_history_delete.php', {
       method: 'POST',
       data: {
         grId: this.groups.history.historyId
       }
     })
     .then( response => {

  this.modalData.sb.text = 'история успешно очищена'
  this.modalData.sb.snackbar = true

  this.groups.history.foundData.selector = false
  this.groups.history.foundData.foundIds = []
  this.groups.history.foundData.displayIds = []
  this.groups.history.foundData.selectedIds = []
  this.groups.history.foundData.offset = 0
  this.groups.history.foundData.selectAll = false

  this.groups.history.foundDataOut.selector  = false
  this.groups.history.foundDataOut.foundIds  = []
  this.groups.history.foundDataOut.displayIds  = []
  this.groups.history.foundDataOut.selectedIds  = []
  this.groups.history.foundDataOut.offset  = 0
  this.groups.history.foundData.selectAll = false
     })
},



close(){
  this.modals.history = false
},

},
beforeUpdate(){

},

computed: {
  metaData(){
    if(this.modals.history){
   this.modalData.header.text = "история активности выбранных сообществ"


      this.modalData.content.items.in.foundData = this.groups.history.foundData
      this.modalData.content.items.in.meneger =   this.groups.history.menegerIn

      this.modalData.content.items.out.foundData = this.groups.history.foundDataOut
      this.modalData.content.items.out.meneger =   this.groups.history.menegerOut

      return this.modalData
    } else return false
    },
},




}
</script>

<style  >

</style>
